import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import AlbumDialog from './Dialog';
import { observable, action, computed } from 'mobx';
import { debounce } from '../../utils/util';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import my from '../../actions/wxuser';
import { IError } from '../../global';
import { IPersonStatus } from '../Followee/Person';
import usePerson from '../Followee/usePerson';
import wxUtil from '../../utils/wx';

interface ISubmitParams {
  image?: string;
  name: string;
  personid?: string;
}
interface IAllForFaceDetectionDialog {
  hide: () => void;
  success?: () => void;
  rootStore?: RootStore;
  personStatus?: IPersonStatus;
  find?: boolean;
}
const containerEl = document.createElement('div');
const AllForFaceDetectionDialog = function(props: IAllForFaceDetectionDialog) {
  const { uiStore, relationStore } = props.rootStore!;
  const { personStatus } = props;
  let editBuddyId = 0; // 当前页面只有新增的情况，没有编辑的情况，这个值不需要取得，直接为0
  let isMe = false;

  if (personStatus) {
    const { faceurl = '', id = 0, status = 'unfollow' } = personStatus;
    if (status === 'follow') {
      editBuddyId = id;
    }
    isMe = status === 'self';
  }

  useEffect(() => {
    document.body.appendChild(containerEl);
    return () => {
      document.body.removeChild(containerEl);
    };
  }, []);
  const commonError = (e: IError) => {
    uiStore.hideToast();
    const { data } = e;
    const { error } = data;
    uiStore.showBasicDialog(error);
    // throw e;//需要把异常抛出去，避免后面正常流程下继续了
  };

  const meEdit = (image: string) => {
    //没有传图就直接认为用户是需要关掉窗口
    if (!image) {
      props.hide();
      return new Promise(resolve => resolve(false));
    }
    uiStore.showToast({ icon: 'loading', content: intl.get('Processing') });
    return my
      .faceUpdateInfo({ image })
      .then((data: any) => {
        if (data && data.success) {
          uiStore.hideToast();
          setTimeout(() => {
            uiStore.showToast({
              content: intl.get('Success'),
              time: 2000,
              icon: 'success-no-circle'
            });
          }, 16);
          //this.userInfo = data;
          // relationStore.updateMyself(window.gallery.id + '');
          relationStore.updateMyself(window.gallery!.id + '').then(() => {
            wxUtil.configPersonShare(relationStore.myself.id);
            return relationStore.getMyselfAlbum(
              window.dataDetail
                ? window.dataDetail.id + ''
                : window.gallery.id + '',
              1
            );
          });
          props.hide();
        } else {
          uiStore.hideToast();
          setTimeout(() => {
            uiStore.showToast({
              content: data.message,
              time: 2000
            });
          }, 16);
        }
      })
      .catch(commonError);
  };
  const editBuddy = (params: ISubmitParams, personid: number) => {
    const { name } = params;
    if (!name) {
      uiStore.showAlert({ content: intl.get('Name is required') });
      return new Promise(resolve => resolve(false));
    }
    return my
      .faceEditBuddy({ personid, name })
      .then(
        action(data => {
          uiStore.showToast({
            content: intl.get('Success'),
            time: 2000,
            icon: 'success-no-circle'
          });
          relationStore.getPerson(window.gallery.id + '', personid, 0);
          props.hide();
        })
      )
      .catch(commonError);
  };
  const addBuddy = (params: ISubmitParams) => {
    const { uiStore } = props.rootStore!;
    let { image, name, personid } = params;
    // 有personid就不需要图片了
    if (!personid) {
      if (!image) {
        uiStore.showAlert({
          content: intl.get('Please upload single frontal photo')
        });
        return new Promise(resolve => resolve(false));
      }
    } else {
      !image && delete params.image;
    }
    if (!name) {
      uiStore.showAlert({ content: intl.get('Name is required') });
      return new Promise(resolve => resolve(false));
    }
    // uiStore.showToast({
    //   icon: 'loading',
    //   content: intl.get('Processing'),
    //   time: 30000
    // });
    return my
      .faceFollow(params)
      .then(
        action((data: any) => {
          let { code, message, success } = data;

          if (success) {
            uiStore.hideToast();
            uiStore.showToast({ content: '添加成功' });
            // 不管有没有Personid都需要调用这个接口，否则从关注的人进入某个人的详情添加后返回，
            // 因为列表没有被更新，所以没有显示这个新增的人
            relationStore.follower();
            setTimeout(() => {
              if (personid) {
                relationStore.getPerson(window.gallery.id + '', +personid, 0);
              }

              props.hide();
            }, 16);

            return true;
          } else {
            uiStore.hideToast();
            uiStore.showToast({ content: message });

            return false;
          }
        })
      )
      .catch(commonError);
  };

  const findBuddy = (image: string) => {
    //没有传图就直接认为用户是需要关掉窗口
    if (!image) {
      props.hide();
      return new Promise(resolve => resolve(false));
    }
    return my
      .findPeople({ image, galleryid: window.gallery.id })
      .then((data: any) => {
        if (data && data.success && data.data) {
          uiStore.hideToast();
          setTimeout(() => {
            uiStore.showToast({
              content: intl.get('Success'),
              time: 2000,
              icon: 'success-no-circle'
            });
          }, 16);

          usePerson(relationStore, Number(data.data), '', undefined, data.faceurl);

          if(props.success) {
            props.success();
          }

          props.hide();
          // relationStore.getFind(window.gallery.id + '', +data.data, 0);
          //
          // relationStore
          //   .getFindPeopleAlbum(
          //     window.dataDetail
          //       ? window.dataDetail.id + ''
          //       : window.gallery.id + '',
          //     data.data,
          //     1
          //   )
          //   .then(res => {
          //     console.log(res);
          //   })
          //   .then(() => {
          //     if (relationStore.findAlbum.total) {
          //       if (props.success) {
          //         props.success();
          //       }
          //
          //       props.hide();
          //     } else {
          //       uiStore.hideToast();
          //       setTimeout(() => {
          //         uiStore.showToast({
          //           content: intl.get('FindPeopleNoResult'),
          //           time: 3000
          //         });
          //       }, 16);
          //     }
          //   });

          return true;
        } else {
          uiStore.hideToast();
          setTimeout(() => {
            console.log(intl.get(`FINDPEOPLE_ERROR_${data.code}`));
            uiStore.showToast({
              // content: data.message,
              content: intl.get(`FINDPEOPLE_ERROR_${data.code}`),
              time: 2000
            });
          }, 16);

          return false;
        }
      })
      .catch(commonError);
  };
  const [isPending, setIsPending] = useState(false);

  const submit = (params: ISubmitParams) => {
    if (isPending) {
      return new Promise(resolve => resolve(false));
    }
    setIsPending(true);

    const { image, name } = params;
    if (isMe) {
      return meEdit(image || '').then(res => {
        setIsPending(false);
        return res;
      });
    } else {
      //编辑还是新增
      if (!!props.find) {
        return findBuddy(image || '').then(res => {
          setIsPending(false);
          return res;
        });
      } else if (editBuddyId) {
        //编辑
        return editBuddy(params, editBuddyId).then(res => {
          setIsPending(false);
          return res;
        });
      } else {
        //新增
        return addBuddy(params).then(res => {
          setIsPending(false);
          return res;
        });
      }
    }
  };

  // const submit = debounce((params: ISubmitParams) => {
  //   //修改个人信息
  //   const { image, name } = params;
  //   if (isMe) {
  //     return meEdit(image || '');
  //   } else {
  //     //编辑还是新增
  //     if (!!props.find) {
  //       return findBuddy(image || '');
  //     } else if (editBuddyId) {
  //       //编辑
  //       return editBuddy(params, editBuddyId);
  //     } else {
  //       //新增
  //       return addBuddy(params);
  //     }
  //   }
  // }, 1000);
  return createPortal(
    <div className="all-for-face-detection-dialog">
      <AlbumDialog
        dialogData={props.personStatus}
        hide={props.hide}
        submit={submit}
        useName={isMe || !!props.find}
        onInvalidFile={(message: string) => {
          uiStore.showAlert({ content: message });
        }}
        // 注意，不要用personStatus.id去标识当前是否是新增或者编辑的人物
        editBuddyId={editBuddyId}
      />
    </div>,
    containerEl
  );
};

export default inject('rootStore')(observer(AllForFaceDetectionDialog));
